// extracted by mini-css-extract-plugin
export default {"cargando":"MensajeTexto_cargando__cuUS7"};